import { ServicesMultiChoiceWUT } from '@wix/form-fields/wut';

export default ServicesMultiChoiceWUT;
